import { enumMarineInsuranceCommodity, enumMarineInsuranceEntityType } from '@data-layer/enums/marine-insurance';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { MarineInsuranceBeneficiaryFromToFormItemModel } from '../models';

export const marineInsuranceBeneficiaryItems: MarineInsuranceBeneficiaryFromToFormItemModel[] = [
  {
    entityType: enumMarineInsuranceEntityType.ISF,
    entities: [
      {
        entityCode: enumEntityModelCode.IMPORTER,
        fieldToMatch: 'importer',
        label: 'ENTITY.IMPORTER',
        isWithPhone: false,
      },
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.CONSIGNEE',
        isWithPhone: true,
      },
      {
        entityCode: enumEntityModelCode.BUYER,
        fieldToMatch: 'buyer',
        label: 'LABELS.BUYER',
        isWithPhone: true,
      },
      {
        entityCode: enumEntityModelCode.SELLER,
        fieldToMatch: 'seller',
        label: 'LABELS.SELLER',
        isWithPhone: true,
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.ENTRY_SUMMARY,
    entities: [
      {
        entityCode: enumEntityModelCode.IMPORTER,
        fieldToMatch: 'importer',
        label: 'ENTITY.IMPORTER',
        isWithPhone: false,
      },
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.CONSIGNEE',
        isWithPhone: true,
      },
      {
        entityCode: enumEntityModelCode.SELLER,
        fieldToMatch: 'seller',
        label: 'LABELS.SELLER',
        isWithPhone: true,
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.LCL_SHIPPING,
    entities: [
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.IMPORTER',
        isWithPhone: false,
      },
      {
        entityCode: enumEntityModelCode.SHIPPER,
        fieldToMatch: 'shipper',
        label: 'LABELS.EXPORTER',
        isWithPhone: false,
      },
    ],
  },
];

export const marineInsuranceFromItems: MarineInsuranceBeneficiaryFromToFormItemModel[] = [
  {
    entityType: enumMarineInsuranceEntityType.ISF,
    entities: [
      {
        entityCode: enumEntityModelCode.SELLER,
        fieldToMatch: 'seller',
        label: 'LABELS.SELLER',
      },
      {
        entityCode: enumEntityModelCode.MANUFACTURER,
        fieldToMatch: 'manufacturer',
        label: 'MANUFACTURER',
      },
      {
        entityCode: enumEntityModelCode.CONSOLIDATOR,
        fieldToMatch: 'consolidator',
        label: 'INFO.CS.TITLE_DESKTOP',
      },
      {
        entityCode: enumEntityModelCode.STAFFING_LOCATION,
        fieldToMatch: 'stuffingLocation',
        label: 'INFO.LG.TITLE',
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.ENTRY_SUMMARY,
    entities: [
      {
        entityCode: enumEntityModelCode.SELLER,
        fieldToMatch: 'seller',
        label: 'LABELS.SELLER',
      },
      {
        entityCode: enumEntityModelCode.MANUFACTURER,
        fieldToMatch: 'manufacturer',
        label: 'MANUFACTURER',
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.LCL_SHIPPING,
    entities: [
      {
        entityCode: enumEntityModelCode.SHIPPER,
        fieldToMatch: 'shipper',
        label: 'LABELS.EXPORTER',
      },
    ],
  },
];

export const marineInsuranceToItems: MarineInsuranceBeneficiaryFromToFormItemModel[] = [
  {
    entityType: enumMarineInsuranceEntityType.ISF,
    entities: [
      {
        entityCode: enumEntityModelCode.IMPORTER,
        fieldToMatch: 'importer',
        label: 'ENTITY.IMPORTER',
      },
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.CONSIGNEE',
      },
      {
        entityCode: enumEntityModelCode.BUYER,
        fieldToMatch: 'buyer',
        label: 'LABELS.BUYER',
      },
      {
        entityCode: enumEntityModelCode.SHIP_TO,
        fieldToMatch: 'shipTo',
        label: 'ENTITY.SHIP_TO',
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.ENTRY_SUMMARY,
    entities: [
      {
        entityCode: enumEntityModelCode.IMPORTER,
        fieldToMatch: 'importer',
        label: 'ENTITY.IMPORTER',
      },
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.CONSIGNEE',
      },
    ],
  },

  {
    entityType: enumMarineInsuranceEntityType.LCL_SHIPPING,
    entities: [
      {
        entityCode: enumEntityModelCode.CONSIGNEE,
        fieldToMatch: 'consignee',
        label: 'ENTITY.IMPORTER',
      },
    ],
  },
];

export const marineInsuranceAmountMaxLimits: { [key: number]: number } = {
  [enumMarineInsuranceCommodity.GENERAL]: 1000000,
  [enumMarineInsuranceCommodity.ELECTRONICS]: 250000,
  [enumMarineInsuranceCommodity.VEHICLES]: 150000,
  [enumMarineInsuranceCommodity.MOBILE_PHONES]: 100000,
  [enumMarineInsuranceCommodity.BOATS_AND_YACHTS]: 500000,
  [enumMarineInsuranceCommodity.FRAGILES]: 150000,
};
